import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-charcoal-dark border-t border-white/5 text-slate-400 py-8 px-4 md:px-8 mt-20 relative overflow-hidden">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-6">
          <div>
            <h3 className="font-bold text-white uppercase tracking-wider text-base mb-2">
              Contact Us
            </h3>
            <p className="text-sm">
              Phone:{' '}
              <a href="tel:502-492-9629" className="text-banana-yellow hover:underline">
                502-492-9629
              </a>
            </p>
            <p className="text-sm mt-1">
              Email:{' '}
              <a
                href="mailto:info@notbychanceoutreach.com"
                className="text-banana-yellow hover:underline"
              >
                info@notbychanceoutreach.com
              </a>
            </p>
          </div>
          <div>
            <h3 className="font-bold text-white uppercase tracking-wider text-base mb-2">
              Quick Links
            </h3>
            <nav className="flex flex-col gap-1 text-sm" aria-label="Footer">
              <Link to="/get-help" className="hover:text-banana-yellow transition-colors">
                Get Help
              </Link>
              <Link to="/help" className="hover:text-banana-yellow transition-colors">
                I Want to Help
              </Link>
              <Link to="/report-camp" className="hover:text-banana-yellow transition-colors">
                Report Camp
              </Link>
              <Link to="/donate" className="hover:text-banana-yellow transition-colors">
                Donate
              </Link>
            </nav>
          </div>
          <div>
            <h3 className="font-bold text-white uppercase tracking-wider text-base mb-2">
              Privacy &amp; Safety
            </h3>
            <p className="text-xs text-slate-500 leading-relaxed mb-2">
              We collect information solely to coordinate outreach. Access is limited to authorized outreach staff.
              Tent Finder is not emergency dispatch and is not monitored continuously.
            </p>
            <p className="text-xs text-slate-500 leading-relaxed mb-2">
              Life-threatening emergency:{' '}
              <a href="tel:911" className="text-urgent-orange font-semibold hover:underline">911</a>
              . Community resources:{' '}
              <a href="tel:211" className="text-banana-yellow font-semibold hover:underline">211</a>.
            </p>
            <Link to="/privacy" className="text-banana-yellow text-xs hover:underline font-semibold uppercase tracking-wider">
              Read Privacy Policy
            </Link>
          </div>
        </div>
        <div className="text-center pt-4 border-t border-white/5 text-xs text-slate-600">
          © {new Date().getFullYear()} Not By Chance Inc. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
